import {Material} from '@domain/materials'
import {TableCell, Typography} from '@mui/material'

import {BooleanValueCell} from './BooleanValueCell'

export const RawMaterialsClassificationRow = ({material}: {material: Material}) => (
  <>
    <BooleanValueCell value={material.classification?.isThermallyProcessedClinkerSubstitute} />
    <TableCell>
      <Typography variant="caption">{material.classification?.category}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.rawMaterialType}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.rawMaterialCategory}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.rawMaterialSubCategory}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.formSize}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.processingDegree}</Typography>
    </TableCell>
  </>
)
